/******************************************************************************
 * Created Date: Tuesday June 9th 2020                                        *
 * Author: Sean W.                                                            *
 * -----                                                                      *
 * Last Modified: Fri Apr 29 2022                                             *
 * Modified By: Sean W.                                                       *
 * -----                                                                      *
 * File: /src/apis/BlobAPI.js                                               *
 * Copyright (c) 2020 MultiSensor                                             *
 ******************************************************************************/

import axios from "axios";
class BlobAPI {
  constructor() {
    this.baseTime = new Date();
    this.getFramesCallStack = []; // if the REACT_APP_BLOB_ENV is set to local, use localhost, otherwise use the cloud server

    this.axiosInstance = axios.create({
      baseURL: `${process.env.REACT_APP_KUVA_API_URL}/blob/v1`,
      timeout: 10000
    });
  }

  static instance = null;

  static Instance = () => {
    if (!this.instance) {
      this.instance = new BlobAPI();
    }
    return this.instance;
  };

  // Allow auth header to be initialized after login
  setAuthToken = token => {
    this.axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${token}`;
  };

  setBaseURI = url => {
    if (this.axiosInstance && process.env.REACT_APP_API_ORIGIN !== "local") {
      this.axiosInstance.defaults.baseURL = `${url}/v1`;
      console.log(
        "CameraAPI url set to: ",
        this.axiosInstance.defaults.baseURL
      );
    }
  };

  setBaseOrgHeader = baseOrg => {
    this.axiosInstance.defaults.headers.common["X-Organization"] = baseOrg;
  };

  getDownloadLink = (container, filename) => {
    console.log(
      `%c calling: ${this.axiosInstance.defaults.baseURL}/downloadfile`,
      "color: #9954E3"
    );

    return this.axiosInstance.get(`downloadfile/${container}/${filename}`);
  };
}

export default BlobAPI.Instance();
